import { render, staticRenderFns } from "./OrderComponent.vue?vue&type=template&id=dcae4ee8&scoped=true"
import script from "./OrderComponent.vue?vue&type=script&lang=js"
export * from "./OrderComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderComponent.vue?vue&type=style&index=0&id=dcae4ee8&prod&lang=scss"
import style1 from "./OrderComponent.vue?vue&type=style&index=1&id=dcae4ee8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcae4ee8",
  null
  
)

export default component.exports